/**
 * @generated SignedSource<<6815d15cef4ea4f3bf6defb9c3956a70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileLayout_userAccount$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"NewProfileSidebar_userAccount" | "UncontrolledHeadlineEditor_userAccount" | "useUserInterfaceFlags_fragment">;
  readonly " $fragmentType": "ProfileLayout_userAccount";
};
export type ProfileLayout_userAccount$key = {
  readonly " $data"?: ProfileLayout_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileLayout_userAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileLayout_userAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUserInterfaceFlags_fragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UncontrolledHeadlineEditor_userAccount"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewProfileSidebar_userAccount"
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};

(node as any).hash = "325492f8823bdf49c649714805fa9780";

export default node;
